import React, { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";

const HobbyItem = (props) => {
  const authContext = useContext(AuthContext);
  const history = useHistory();
  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #e1e1e1",
        padding: "5px 5px 5px 0px",
      }}
    >
      <p
        style={{
          margin: "0",
          marginRight: "10px",
          padding: "15px 0%",
        }}
      >
        {props.hobby.name}
      </p>
      {props.editing && (
        <IconButton
          variant="outlined"
          color="secondary"
          style={{ justifySelf: "flex-end" }}
          onClick={() => props.removeHobby(props.hobby)}
        >
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default HobbyItem;
